import * as React from 'react';
import { css, StyleSheet } from 'aphrodite';
import { MediaBreakPointUp } from '@lean-body/components/styles';
import SearchTitle from './search_title';
export const SearchLandingInstructors = ({ items, onClick }) => {
    return (React.createElement("section", null,
        React.createElement(SearchTitle, null, "\uD83C\uDFA4 \u30A4\u30F3\u30B9\u30C8\u30E9\u30AF\u30BF\u30FC"),
        React.createElement("div", { className: css(styles.instructors) }, items.map((item) => (React.createElement("div", { key: item.id, className: css(styles.instructorItem), onClick: () => onClick(item.id) },
            React.createElement("img", { className: css(styles.instructorImg), src: item.imageUrl, alt: "" }),
            React.createElement("span", { className: css(styles.instructorLabel) }, item.name)))))));
};
const styles = StyleSheet.create({
    instructors: {
        display: 'grid',
        gridTemplateColumns: 'repeat(5, 1fr)',
        columnGap: '2px',
        rowGap: '16px',
        [MediaBreakPointUp.MD]: {
            display: 'flex',
            flexWrap: 'wrap',
            justifyContent: 'flex-start',
            columnGap: '25px',
            rowGap: '16px',
        },
    },
    instructorItem: {
        width: '100%',
        minWidth: 0,
        cursor: 'pointer',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        gap: 4,
        [MediaBreakPointUp.MD]: {
            width: 70,
        },
    },
    instructorLabel: {
        width: '100%',
        overflowWrap: 'anywhere',
        fontSize: 12,
        lineHeight: '140%',
        textAlign: 'center',
    },
    instructorImg: {
        width: 56,
        height: 56,
        borderRadius: '50%',
        objectFit: 'cover',
        [MediaBreakPointUp.MD]: {
            width: 70,
            height: 70,
        },
    },
});
